var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.preview || _vm.model,
          expression: "!preview || model",
        },
      ],
    },
    [
      _vm.template.type === "GROUP"
        ? _c("questionnaire-edit-section-group", {
            attrs: {
              model: _vm.model,
              preview: _vm.preview,
              template: _vm.template,
            },
            on: {
              mounted: _vm.onSectionMounted,
              questionAdded: _vm.$rbEmit,
              questionRemoved: _vm.$rbEmit,
              sectionAdded: _vm.$rbEmit,
              sectionRemoved: _vm.$rbEmit,
              questionRequiredChanged: _vm.$rbEmit,
              userDefinedChanged: _vm.$rbEmit,
              userDefinedRemoved: _vm.$rbEmit,
            },
          })
        : _vm.template.type === "TABLE"
        ? _c("questionnaire-edit-section-table", {
            attrs: {
              config: _vm.config,
              model: _vm.model,
              preview: _vm.preview,
              template: _vm.template,
            },
            on: {
              mounted: _vm.onSectionMounted,
              tableAdded: _vm.$rbEmit,
              tableRemoved: _vm.$rbEmit,
              tableConfigure: _vm.$rbEmit,
            },
          })
        : _vm.template.type === "HOTEL_RFP_RATE_GRID"
        ? _c("questionnaire-edit-hotel-rfp-rate-grid", {
            attrs: {
              config: _vm.config,
              model: _vm.model,
              preview: _vm.preview,
              template: _vm.template,
            },
            on: { specialsChanged: _vm.$rbEmit, mounted: _vm.onSectionMounted },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }